import React, { useState, useEffect } from "react";
import enrolledClasses from "../enrolled/enrolled.module.css";
import Layout from "../../../Components/Layout/index";
import { Helmet } from "react-helmet";
import { Services } from "../../../Services";
import SkeletonLoad from "Components/loader/loader";
import ReactPaginate from "react-paginate";
import useStore from "../../../store";
import {
    Error,
    Success,
    Success_Dark,
    SuccessSwal,
    warningSwal,
} from "../../../Util/Toast";
import { AiFillEdit } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import Filter from "../enrolled/filter/filter";
import Loader from "../../../Components/loader/fallingLines";
import PaymentModal from "../enrolled/generatePaymentLink/generate";
import swal from "sweetalert";
import Moment from "react-moment";
import { toast } from "react-toastify";
import { FaFileExport } from "react-icons/fa6";
import { useSearchParams } from "react-router-dom";
function Tutor({ Type }) {
    const Navigate = useNavigate();
    const [forcepage, setforcepage] = useState(0);
    const [searchparams, setSearchParams] = useSearchParams();
    const RecordCount = useStore((item) => item.NoOfRecords);
    const [pageCount, setpageCount] = useState(1);
    const [showPaginate, setShowPagiate] = useState(true);
    const [filter, setFilter] = useState(false);
    const [loading, setLoading] = useState(true);
    const [Tutor, setTutors] = useState([]);
    const [body, setBody] = useState({
        counter: 0,
        whether_Batch_filter: 0,
        whether_Course_filter: 0,
        whether_PreferredDays_filter: 0,
        whether_Age_filter: 0,
        whether_Time_filter: 0,
        whether_Payment_filter: 0,
    });
    const [Active, setActive] = useState("0");
    const [data, setData] = useState([]);
    const [enrollCourseId, setEnrollCourseId] = useState("");
    const token = { Authorization: `token ${localStorage.getItem("token")}` };
    const admindata = JSON.parse(localStorage.getItem("admindata"));

    // Filter States
    const [filterLoad, setFilterLoad] = useState(false);
    const [showFilter, setShowFilter] = useState(false);

    const [showPaymentModal, setShowPaymentModal] = useState(false);

    const getAllCategories = async () => {
        setLoading(true);

        let data = JSON.stringify({
            ...body,
            IsAddedToBatch: Type == "registration_batch_created" ? "1" : "0",
            Enrolled_Type: Type == "registration_new_created" ? "web" : "admin",
            toSkip: forcepage * RecordCount,
            toLimit: RecordCount,
        });

        if (Tutor.length == 0) {
            await FetchDropDowns();
        }

        Services.enrolled_List_Filter("POST", data, token)
            .then((response) => {
                setTimeout(() => {
                    setLoading(false);
                    setFilterLoad(false);
                }, 200);

                if (response.Status === 1) {
                    setData(response.Enquires);
                    if (
                        response.Enquires.length == 0 ||
                        response.Count <= RecordCount
                    ) {
                        setShowPagiate(false);
                    } else {
                        if (!showPaginate) {
                            setShowPagiate(true);
                        }
                        setpageCount(
                            Math.ceil(Number(response?.Count) / RecordCount)
                        );
                    }
                } else if (response.Status === 0) {
                    warningSwal("warning", response.Message);
                }
            })
            .catch((err) => {
                setLoading(false);
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    const FetchDropDowns = async () => {
        try {
            const [response1] = await Promise.all([
                Services.GetTutors(
                    "POST",
                    JSON.stringify({ TutorStatus: 1 }),
                    token
                ),
            ]);

            setTutors(response1.Tutors);
        } catch (error) {
            alert("something went wrong please try again");
            console.error("Error fetching data:", error);
        }
    };
    const ExportHandler = async () => {
        setFilterLoad(true);
        try {
            const [response1] = await Promise.all([
                Services.ExportStudentRegistraion("POST", null, token),
            ]);
            if (response1.Status == 1) {
                window.open(response1?.DownloadLink, "_blank");
            }
        } catch (error) {
            alert("something went wrong please try again");
            console.error("Error fetching data:", error);
        } finally {
            setFilterLoad(false);
        }
    };
    const changePaymentStatus = (status, id, coursename) => {
        Services.paymentStatus(
            "PUT",
            JSON.stringify({ PaymentStatus: status, CourseName: coursename }),
            token,
            id
        )
            .then((response) => {
                setFilterLoad(false);
                if (response.Status === 1) {
                    SuccessSwal(
                        "Success",
                        "Marked Regitration as paid Successfully!"
                    );
                    getAllCategories();
                } else {
                    warningSwal("Warning", response?.Message);
                }
            })
            .catch((err) => {
                setFilterLoad(false);
                // alert(err);
                setLoading(false);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    useEffect(() => {
        let page = searchparams.get("page");
        if (Number(page) - 1 == forcepage) {
            getAllCategories();
        } else {
            setforcepage(Number(page) - 1);
        }
        // eslint-disable-next-line
    }, [body, forcepage]);

    const handlePageChange = (selectedObject) => {
        console.log(selectedObject);
        // setcurrentPage(selectedObject.selected);
        // handleFetch();
        setSearchParams({ page: selectedObject.selected + 1 });
        window.scrollTo({ top: 10, behavior: "instant" });
        setforcepage(selectedObject.selected);
    };

    const claimHandler = (e, demoTaken) => {
        e.preventDefault();
        e.stopPropagation();

        let EnrollCourseID = e.currentTarget.getAttribute("EnrollCourseID");
        let coursename = e.currentTarget.getAttribute("coursename");
        let body = {
            IsClaimed: 1,
            ClaimedBy: admindata.AdminUserID,
            CourseName: coursename,
        };
        if (demoTaken == null || demoTaken == undefined || demoTaken == 0) {
            warningSwal(
                "Warning",
                "Please Add demo Taken By before claiming the student"
            );
            return;
        }
        swal("Are you sure Claim the User?", {
            icon: "warning",
            // className: detailsClass["logout-popup"],
            dangerMode: true,
            buttons: {
                cancel: "Cancel",
                catch: {
                    text: "Confirm",
                    value: "Logout",
                    className: enrolledClasses["cancel"],
                },
                defeat: false,
            },
        }).then((value) => {
            switch (value) {
                case "Logout":
                    setFilterLoad(true);
                    Services.Claim_Enroll_Course(
                        "PUT",
                        JSON.stringify(body),
                        token,
                        EnrollCourseID
                    )
                        .then((res) => {
                            if (res.Status === 1) {
                                SuccessSwal(
                                    "Success",
                                    "Student profile claimed successfully"
                                );
                                getAllCategories();
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                            setLoading(false);
                            Error("something went Wrong Please try again");
                        });
                    break;

                // default:
                //     swal("Got away safely!");
            }
        });
    };

    const DetailsHandler = (e, item) => {
        let id = e.currentTarget.getAttribute(`id`);

        if (
            admindata.Type == 1 ||
            admindata.Type == 8 ||
            admindata.Type == 7 ||
            admindata.Type == 6 ||
            admindata?.AdminUserID == item?.Enrolled_By_ID ||
            admindata?.AdminUserID == item.ClaimedBy ||
            item.TutorRms.includes(admindata.AdminUserID)
        ) {
            Navigate(`/Student-registration/details?id=${id}`, {
                state: {
                    Active: Type,
                },
            });
        }
    };
    const paidHandler = (e) => {
        e.stopPropagation();
        let id = e.currentTarget.getAttribute("courseId");
        let coursename = e.currentTarget.getAttribute("coursename");
        swal(
            "Are You Sure you want to mark status as Paid ,the price per class will be  zero and will not be reflected towards revenue?",
            {
                icon: "warning",
                // className: detailsClass["logout-popup"],
                dangerMode: true,
                buttons: {
                    cancel: "Cancel",
                    catch: {
                        text: "Confirm",
                        value: "Logout",
                        className: enrolledClasses["cancel"],
                    },
                    defeat: false,
                },
            }
        ).then((value) => {
            switch (value) {
                case "Logout":
                    setFilterLoad(true);
                    changePaymentStatus(1, id, coursename);
                    break;

                // default:
                //     swal("Got away safely!");
            }
        });
    };
    const ClaimOnClickHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };
    const copyToClipboard = (e) => {
        e.stopPropagation();
        const text = e.currentTarget.getAttribute("PaymentLink");

        navigator.clipboard.writeText(text).then(() => {
            Success_Dark("Copied");
        });
    };
    const NavHandler = (e) => {
        let buttonType = e.currentTarget.getAttribute("btn-type");
        setActive(buttonType);
        setLoading(true);
        setBody((prev) => ({ ...prev, IsAddedToBatch: buttonType }));
    };
    const copyHandler = (e) => {
        e.stopPropagation();
        let number = e.currentTarget.getAttribute("number");
        navigator.clipboard.writeText(number);
        Success_Dark("Copied to clipboard");
    };
    function maskMobileNumber(mobile) {
        if (!mobile || mobile.length < 4) {
            return "Invalid number";
        }
        const lastFour = mobile.slice(-4);
        const masked = "x".repeat(mobile.length - 4) + lastFour;
        return masked;
    }
    const changeHandler = (e, id) => {
        Services.updateEnrolledCourse2(
            "PUT",
            JSON.stringify({
                DemoTakenBy: e.target.value,
            }),
            token,
            id
        )
            .then((response) => {
                if (response.Status === 1) {
                    getAllCategories();
                    SuccessSwal("Success", " Updated Successfully");
                } else if (response.Status === 0) {
                    setLoading(false);
                    toast.error(`${response.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            })
            .catch((err) => {
                // alert(err);
                setLoading(false);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    return (
        <Layout Active={Type}>
            {filterLoad && <Loader />}
            {showFilter && (
                <Filter
                    setShowFilter={setShowFilter}
                    showFilter={showFilter}
                    setBody={setBody}
                    Active={Active}
                    setFilter={setFilter}
                    setFilterLoad={setFilterLoad}
                    body={body}
                />
            )}
            {showPaymentModal && (
                <PaymentModal
                    setShowPaymentModal={setShowPaymentModal}
                    showPaymentModal={showPaymentModal}
                    data={data}
                    enrollCourseId={enrollCourseId}
                    getAllCategories={getAllCategories}
                />
            )}
            <Helmet>
                <meta charSet="utf-8" />
                <title>
                    {Type == "registration_new_created"
                        ? "New Registration"
                        : Type == "registration_Added"
                        ? "Added Registration"
                        : "Batch Created"}
                </title>
            </Helmet>
            <div className={enrolledClasses["Container"]}>
                <div className={enrolledClasses["control-btns"]}>
                    <button
                        className={enrolledClasses["button"]}
                        onClick={() => setShowFilter(true)}>
                        Filter
                    </button>
                </div>
                {filter && (
                    <div className={enrolledClasses["filteredOptions"]}>
                        <div className={enrolledClasses["options"]}>
                            <span>Filters:</span>
                            {Object.keys(filter)
                                .map((key) => ({
                                    key: key,
                                    value: filter[key],
                                }))
                                .map((item) => (
                                    <div>
                                        <p>{item.key}</p>
                                        <p>{item.value}</p>
                                    </div>
                                ))}
                        </div>
                        <button
                            onClick={() => {
                                setFilter(false);
                                setBody({
                                    counter: 0,
                                    whether_Batch_filter: 0,
                                    whether_Course_filter: 0,
                                    whether_PreferredDays_filter: 0,
                                    whether_Age_filter: 0,
                                    whether_Time_filter: 0,
                                    whether_Payment_filter: 0,
                                    whether_claimedbyname_filter: 0,
                                    whether_parentname_filter: 0,
                                    whether_studentname_filter: 0,
                                });
                                setSearchParams({ page: 1 });
                            }}>
                            Clear Filter
                        </button>
                    </div>
                )}
                <div className={enrolledClasses["Tutor"]}>
                    <h3>
                        {Type == "registration_new_created"
                            ? "New Registration"
                            : Type == "registration_Added"
                            ? "Added Registration"
                            : "Batch Created"}
                        {Type == "registration_Added" &&
                            (admindata?.Type == 1 ||
                                admindata?.Type == 2 ||
                                admindata?.Type == 11 ||
                                admindata?.Type == 9 ||
                                admindata?.Type == 6 ||
                                admindata?.Type == 5 ||
                                admindata?.Type == 10 ||
                                admindata?.Type == 7) && (
                                <button
                                    onClick={() =>
                                        Navigate(
                                            "/Student-registration/new-registration/add",
                                            {
                                                state: {
                                                    Active: Type,
                                                },
                                            }
                                        )
                                    }>
                                    Add Registration
                                </button>
                            )}
                    </h3>

                    {loading ? (
                        <SkeletonLoad count={3} />
                    ) : data.length > 0 ? (
                        <>
                            <div className={enrolledClasses["Table"]}>
                                <table style={{ minWidth: "1600px" }}>
                                    <thead>
                                        <tr>
                                            {(admindata.Type === 5 ||
                                                admindata.Type == 10) &&
                                                Type ==
                                                    "registration_new_created" && (
                                                    <th></th>
                                                )}
                                            <th>Student Name </th>
                                            {/* <th>Student </th> */}
                                            <th>Parent Details </th>
                                            <th>Course </th>
                                            {Type != "registration_Added" && (
                                                <th>Claimed By</th>
                                            )}
                                            <th>Registration </th>
                                            {Type !=
                                                "registration_new_created" && (
                                                <th>Created By</th>
                                            )}
                                            {/* <th>Preferred Times</th> */}
                                            <th>Payment Details</th>
                                            <th>Demo Taken By</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map((item) => (
                                            <tr
                                                onClick={(e) =>
                                                    DetailsHandler(e, item)
                                                }
                                                id={item.EnrollCourseID}>
                                                {(admindata.Type === 5 ||
                                                    admindata.Type == 10) &&
                                                    Type ==
                                                        "registration_new_created" && (
                                                        <td
                                                            style={{
                                                                width: "2rem",
                                                            }}>
                                                            <input
                                                                onClick={
                                                                    ClaimOnClickHandler
                                                                }
                                                                onChange={(e) =>
                                                                    claimHandler(
                                                                        e,
                                                                        item.DemoTakenBy
                                                                    )
                                                                }
                                                                type="checkbox"
                                                                disabled={
                                                                    item.IsClaimed ===
                                                                    1
                                                                }
                                                                coursename={
                                                                    item.CourseName
                                                                }
                                                                defaultChecked={
                                                                    item.IsClaimed ===
                                                                    1
                                                                }
                                                                checked={
                                                                    item.IsClaimed ===
                                                                    1
                                                                }
                                                                EnrollCourseID={
                                                                    item.EnrollCourseID
                                                                }
                                                            />
                                                        </td>
                                                    )}
                                                <td>
                                                    {" "}
                                                    {item.StudentName} <br />(
                                                    {item.StudentAge} years)
                                                </td>
                                                {/* <td> {item.StudentName}</td> */}
                                                <td number={item.MobileNumber}>
                                                    {item.ParentName}
                                                    <br />

                                                    <span
                                                        style={{
                                                            lineHeight: "2rem",
                                                        }}>
                                                        {item.CountryCode}

                                                        {admindata.Type == 1 ||
                                                        admindata.Type == 8 ||
                                                        admindata?.Type == 6 ||
                                                        admindata.Type == 7
                                                            ? item.MobileNumber
                                                            : maskMobileNumber(
                                                                  item.MobileNumber
                                                              )}
                                                        {/* 
                                                    {(admindata.Type == 1 ||
                                                        admindata?.Type ==
                                                            6) && (
                                                        <button
                                                            style={{
                                                                backgroundColor:
                                                                    "inherit",
                                                                border: "none",
                                                                marginLeft:
                                                                    "0.5rem",
                                                            }}
                                                            title="Copy"
                                                            number={
                                                                item.MobileNumber
                                                            }>
                                                            <FaCopy />
                                                        </button>
                                                    )}
                                                    */}
                                                    </span>
                                                </td>

                                                <td style={{ width: "10rem" }}>
                                                    {item.CourseName} <br />
                                                    <span
                                                        style={{
                                                            lineHeight: "2rem",
                                                        }}>
                                                        ({item.BatchSize})
                                                    </span>
                                                </td>
                                                {Type !=
                                                    "registration_Added" && (
                                                    <td>
                                                        {item.ClaimedByName}
                                                    </td>
                                                )}
                                                <td>
                                                    <Moment
                                                        format={"DD-MM-YYYY"}>
                                                        {
                                                            new Date(
                                                                item.CreatedAt
                                                            )
                                                        }
                                                    </Moment>
                                                </td>
                                                {/* <td>{item.PreferredStartTimes}</td> */}
                                                {Type !=
                                                    "registration_new_created" && (
                                                    <td
                                                        style={{
                                                            maxWidth: "13rem",
                                                        }}>
                                                        {item.Enrolled_By_Name}
                                                    </td>
                                                )}
                                                <td>
                                                    ₹{item.PricePaid} <br />
                                                    {item.PaymentStatus ==
                                                        1 && (
                                                        <Moment
                                                            format={
                                                                "DD-MM-YYYY"
                                                            }
                                                            utc>
                                                            {
                                                                new Date(
                                                                    item.PaymentDateTime
                                                                )
                                                            }
                                                        </Moment>
                                                    )}
                                                </td>
                                                <td>
                                                    <select
                                                        style={{
                                                            maxWidth: "10rem",
                                                            height: "2rem",
                                                            borderRadius:
                                                                "0.5rem",
                                                            border: "1px solid #ccc",
                                                            textAlign: "center",
                                                        }}
                                                        defaultValue={
                                                            item.DemoTakenBy
                                                        }
                                                        onClick={(e) =>
                                                            e.stopPropagation()
                                                        }
                                                        onChange={(e) =>
                                                            changeHandler(
                                                                e,
                                                                item.EnrollCourseID
                                                            )
                                                        }>
                                                        <option
                                                            value={0}
                                                            disabled>
                                                            Demo Taken By
                                                        </option>

                                                        <option value={-1}>
                                                            None
                                                        </option>

                                                        {Tutor?.map((item) => (
                                                            <option
                                                                value={
                                                                    item.TutorID
                                                                }>
                                                                {item.TutorName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </td>
                                                <td
                                                    className={
                                                        enrolledClasses[
                                                            "payment-status"
                                                        ]
                                                    }>
                                                    {item.PaymentStatus == 0 ? (
                                                        <span
                                                            className={
                                                                enrolledClasses[
                                                                    "pending"
                                                                ]
                                                            }>
                                                            <span>
                                                                Link Not
                                                                Generated
                                                            </span>{" "}
                                                        </span>
                                                    ) : item.PaymentStatus ==
                                                      1 ? (
                                                        <span
                                                            className={
                                                                enrolledClasses[
                                                                    "paid-status"
                                                                ]
                                                            }>
                                                            Paid
                                                        </span>
                                                    ) : item.PaymentStatus ==
                                                      2 ? (
                                                        <>
                                                            <span
                                                                className={
                                                                    enrolledClasses[
                                                                        "link-generated"
                                                                    ]
                                                                }>
                                                                Generated
                                                            </span>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <span
                                                                className={
                                                                    enrolledClasses[
                                                                        "pending"
                                                                    ]
                                                                }>
                                                                Payment Failed
                                                            </span>
                                                        </>
                                                    )}
                                                </td>

                                                <td>
                                                    <div
                                                        className={
                                                            enrolledClasses[
                                                                "action-btns"
                                                            ]
                                                        }>
                                                        {/* {(item.PaymentStatus ===
                                                        0 ||
                                                        item.PaymentStatus ===
                                                            1) && (
                                                        <button
                                                            className={
                                                                enrolledClasses[
                                                                    "generate"
                                                                ]
                                                            }
                                                            disabled={
                                                                item.PaymentStatus !==
                                                                0
                                                            }
                                                            courseId={
                                                                item.EnrollCourseID
                                                            }
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setShowPaymentModal(
                                                                    true
                                                                );
                                                                setEnrollCourseId(
                                                                    e.currentTarget.getAttribute(
                                                                        "courseId"
                                                                    )
                                                                );
                                                            }}>
                                                            Generate Link
                                                        </button>
                                                    )} */}

                                                        <div
                                                            div
                                                            className={
                                                                enrolledClasses[
                                                                    "copy-link"
                                                                ]
                                                            }>
                                                            <button
                                                                className={
                                                                    enrolledClasses[
                                                                        "paid"
                                                                    ]
                                                                }
                                                                courseId={
                                                                    item.EnrollCourseID
                                                                }
                                                                coursename={
                                                                    item.CourseName
                                                                }
                                                                disabled={
                                                                    item.PaymentStatus !==
                                                                        2 &&
                                                                    item.PaymentStatus !==
                                                                        3 &&
                                                                    item.PaymentStatus !=
                                                                        0
                                                                }
                                                                onClick={
                                                                    paidHandler
                                                                }>
                                                                Mark as Paid
                                                            </button>
                                                            {item.PaymentStatus ===
                                                                2 && (
                                                                <button
                                                                    className={
                                                                        enrolledClasses[
                                                                            "copy"
                                                                        ]
                                                                    }
                                                                    disabled={
                                                                        item.PaymentStatus !==
                                                                        2
                                                                    }
                                                                    onClick={
                                                                        copyToClipboard
                                                                    }
                                                                    PaymentLink={
                                                                        item.PaymentLink
                                                                    }>
                                                                    Copy
                                                                </button>
                                                            )}
                                                        </div>
                                                        {item.IsAddedToBatch ===
                                                            0 &&
                                                            (admindata.Type ==
                                                                1 ||
                                                                admindata.Type ==
                                                                    7 ||
                                                                admindata.Type ==
                                                                    8 ||
                                                                admindata.Type ==
                                                                    6 ||
                                                                admindata?.AdminUserID ==
                                                                    item.ClaimedBy ||
                                                                admindata?.AdminUserID ==
                                                                    item?.Enrolled_By_ID) && (
                                                                <button
                                                                    onClick={(
                                                                        E
                                                                    ) => {
                                                                        E.stopPropagation();
                                                                        sessionStorage.setItem(
                                                                            "enrolled",
                                                                            JSON.stringify(
                                                                                item
                                                                            )
                                                                        );
                                                                        Navigate(
                                                                            `/Student-registration/new-registration/edit/${item.EnrollCourseID}`,
                                                                            {
                                                                                state: {
                                                                                    Active: Type,
                                                                                    Type: item.Enrolled_By_Type,
                                                                                },
                                                                            }
                                                                        );
                                                                    }}
                                                                    style={{
                                                                        border: "none",
                                                                        backgroundColor:
                                                                            "inherit",
                                                                        cursor: "pointer",
                                                                    }}>
                                                                    <AiFillEdit
                                                                        size={
                                                                            18
                                                                        }
                                                                    />
                                                                </button>
                                                            )}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            {showPaginate && (
                                <div
                                    style={{
                                        justifySelf: "right",
                                    }}>
                                    <ReactPaginate
                                        pageCount={pageCount}
                                        // pageRange={2}
                                        forcePage={forcepage}
                                        marginPagesDisplayed={2}
                                        onPageChange={handlePageChange}
                                        breakClassName={"page-item"}
                                        breakLinkClassName={"page-link"}
                                        containerClassName={"pagination"}
                                        pageClassName={"page-item"}
                                        pageLinkClassName={"page-link"}
                                        previousClassName={"page-item"}
                                        previousLinkClassName={"page-link"}
                                        nextClassName={"page-item"}
                                        nextLinkClassName={"page-link"}
                                        activeClassName={"active"}
                                    />
                                </div>
                            )}
                        </>
                    ) : (
                        <div>
                            {" "}
                            <p>No Data Found</p>
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    );
}

export default Tutor;
